import { RemoteConfigProperties } from "../../../../types";
export function validators(sdk) {
    return {
        name: (_group, value) => {
            if (!value?.trim()) {
                return "Name is required.";
            }
            return undefined;
        },
        publishers: (_group, value) => {
            if (!Array.isArray(value) || value.length === 0) {
                return "At least one publisher is required.";
            }
            return undefined;
        },
        productId: (_group, value) => {
            const isProductAllowed = sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.PUB_LIST_PRODUCTS);
            if (!isProductAllowed) {
                return undefined;
            }
            if (!value || (typeof value === "string" && !value.trim())) {
                return "Product is required.";
            }
            return undefined;
        }
    };
}
//# sourceMappingURL=index.js.map